export default {
  title_requirements: "Additional Requirements",
  title_time_requirements: "Time Requirements",
  title_action: "Corrective Action",
  label_isolation: "Requires isolation",
  label_shutdown: "Requires shutdown",
  label_input_action: "Select or write a Corrective Action",
  label_hours: "Hours",
  label_minutes: "Minutes",
  dialog_title: "Discarding entry",
  dialog_content: "Are you sure you want to discard this entry?",
  disabled_icon_info_message: "Cannot be filled unless Corrective Action has been added.",
}
